import FieldBase from './FieldBase'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import { uniqueId } from 'lodash'

export default class extends FieldBase {
  constructor({ id, placeChangedCallback, ...args }) {
    super(args)
    this.children = [
      {
        component: VueGoogleAutocomplete,
        attrs: {
          id: id || 'map',
          country: 'pl',
          classname: 'el-input__inner'
        },
        listeners: {
          placechanged: placeChangedCallback
        }
      }
    ]
  }
}
